import DossierContact from '@/contact/models/DossierContact';
import { ContactTarget } from '@/customer/models/Customer';
import { isPresent } from '../utils/typescript';

export default class DossierContactTarget {
  constructor(
    public readonly contact: DossierContact,
    public readonly target: ContactTarget,
  ) {
  }

  static forTargetOfContacts(target: ContactTarget, contacts: Array<DossierContact>): DossierContactTarget | undefined {
    const contact = contacts.find(c => c.customer?.hasContactTarget(target));
    if (contact) return new DossierContactTarget(contact, target);
  }

  static forAllTargetsOfContacts(targets: Array<ContactTarget>, contacts: Array<DossierContact>): Array<DossierContactTarget> {
    return targets.map(t => DossierContactTarget.forTargetOfContacts(t, contacts)).filter(isPresent);
  }

  get isSms(): boolean {
    return this.contact.customer?.mobilePhones.includes(this.target) ?? false;
  }

  isEmail(): boolean {
    return this.contact.customer?.emails.includes(this.target) ?? false;
  }

  isEqual(that: DossierContactTarget): boolean {
    return this.contact.id === that.contact.id && this.target === that.target;
  }
}